<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <div class="entityView">
            <keep-alive exclude="ResearchRequestReader">
                <router-view></router-view>
            </keep-alive>
        </div>
    </v-container>
</template>
<script>
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
import permissionsSet from '../../components/permissions'
const entity = 'research'
export default {
    name: 'ResearchHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'List', icon: 'mdi-view-list', to: 'research' },
                { title: 'Archive', icon: 'mdi-delete-outline', to: 'researchArchive' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newResearch' }, ...items]

            return items
        },
        canCreate() {
            console.log(this.user)
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
    },
}
</script>
<style>
.entityView {
    width: 100%;
}
</style>
